import React from 'react';
import './Searchnav.css';
import WelcomeName from './WelcomeName';

function Searchnav() {
    return (
        <>
        <div role="region" aria-label="skip navigation">
            <a href="#main" class="cmp-skip-link">Skip to main content</a>
            {/* <a href="#footer" class="cmp-skip-link">Skip to footer</a> */}
            </div>
            <div class="searchnav-container">
                <div class="searchnav-wrap">
                    <div class="searchnav-row">
                        <div class="searchnav-box logoBlock" style={{ textAlign: 'left', marginTop: '0px' }}>
                            <div tabIndex={0}>
                            <img src="images/Acc_Logo_Black_Purple_RGB.png" class="acc-logo" alt="Accenture logo"/>
                            </div>
                            
                            <p class="desktop-tag"><a href="https://atc.lkm.accenture.com/home"> Learning and Knowledge Management, ATC</a></p>
                            <p class="mobile-tag"><a href="https://atc.lkm.accenture.com/home"> LKM</a></p>
                        </div>
                    </div>
                    <div class="searchnav-row">
                        <div class="searchnav-box userBlock" style={{ textAlign: 'right', marginTop: '5px' }}>                            
                            <div className='userRow'>
                            <WelcomeName />                            
                                <img src="images/Avatar.png" class="user-img" alt="user-image" />                                                                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Searchnav
